export default __webpack_public_path__ + "MB-star_p_3Coffice white.png";